import { render, staticRenderFns } from "./warn_items_list.vue?vue&type=template&id=27a754ac&scoped=true"
import script from "./warn_items_list.vue?vue&type=script&lang=js"
export * from "./warn_items_list.vue?vue&type=script&lang=js"
import style0 from "./warn_items_list.vue?vue&type=style&index=0&id=27a754ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a754ac",
  null
  
)

export default component.exports